module.exports = __webpack_public_path__ + "730c0383d6d488800ee5e63c68724499.svg";